'use client'

import { useEffect, useState } from 'react'

import { IS_PRODUCTION } from '@/shared/lib'

const SEO_ONELINK_QUERY_KEY = 'seoOnelink'

/** `?seoOnelink=`로 임의 도메인에 보내지 못하게 막고, 운영 외에서는 운영 host를 거부해 dev 앱으로 열리게 한다 */
const ALLOWED_ONELINK_HOSTS = new Set(
  IS_PRODUCTION
    ? ['mycle.onelink.me', 'mycle-ss.onelink.me', 'web-seo-geo.onelink.me']
    : ['web-dev-seo-geo.onelink.me']
)

const isSafeOnelinkUrl = (value: string): boolean => {
  try {
    const parsed = new URL(value)
    if (parsed.protocol !== 'https:') return false
    return ALLOWED_ONELINK_HOSTS.has(parsed.hostname)
  } catch {
    return false
  }
}

/** 정적 prerender에서 Suspense 경계를 강제하지 않도록 useSearchParams 대신 window.location을 읽는다 */
export const useSeoOnelinkUrl = (fallbackUrl: string) => {
  const [url, setUrl] = useState<string>(fallbackUrl)

  useEffect(function applySeoOnelinkFromQuery() {
    const seoOnelink = new URLSearchParams(window.location.search).get(
      SEO_ONELINK_QUERY_KEY
    )
    if (seoOnelink && isSafeOnelinkUrl(seoOnelink)) setUrl(seoOnelink)
  }, [])

  return url
}
